import React from 'react';
import cuid from 'cuid';

import Text from '../uiElem/Text';

import ValidationError from './ValidationError';
import Note from './Note';

const Checkbox = ({
  input,
  label,
  helper,
  meta: {error, touched} = {},
  disabled,
  id = cuid(),
  showError = true,
  ...rest
}) => (
  <>
    <label
      className={`inline-block ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
      htmlFor={id}>
      <div className="flex items-start">
        <div className="w-4 flex-shrink-0" style={{paddingTop: '2px'}}>
          <input
            id={id}
            {...input}
            {...rest}
            type="checkbox"
            disabled={disabled}
          />
        </div>

        <Text className="ml-2">{label}</Text>
      </div>
    </label>

    {helper && <Note value={helper} />}
    {error && touched && showError && <ValidationError value={error} />}
  </>
);

export default Checkbox;
